<div class="dashboard-container">
  <div class="sticky-header">
    <div class="header-column">
      <h1 class="dashboard-title">Organizations</h1>
      <div class="search-row">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            [ngModel]="orgSearch()"
            (ngModelChange)="orgSearch.set($event); onOrgSearchInput()"
            placeholder="Search companies..."
            class="org-search-input"
          />
        </span>
        <span class="user-search-wrapper">
          <p-autoComplete
            [ngModel]="userSearch()"
            (ngModelChange)="userSearch.set($event)"
            [suggestions]="userResults()"
            (completeMethod)="onUserSearchInput($event.query)"
            (onSelect)="onUserSelected($event.value)"
            optionLabel="name"
            placeholder="Find employee (name/email)..."
            [dropdown]="false"
            inputStyleClass="user-search-input"
          >
            <ng-template pTemplate="item" let-user>
              <div>
                <div class="font-medium">{{ user.name }}</div>
                <div class="text-xs text-500">
                  {{ user.email }} · {{ user.organisationName || 'No org' }}
                </div>
              </div>
            </ng-template>
          </p-autoComplete>
        </span>
      </div>
    </div>
    <div class="header-actions">
      <app-date-range-selector
        [selectedPeriod]="selectedPeriod()"
        [startDate]="startDate()"
        [endDate]="endDate()"
        [includeWeek]="false"
        (periodChange)="onPeriodChange($event)"
        (dateRangeChange)="onDateRangeChange($event)"
      />
      <p-button label="Invite Organization" icon="pi pi-plus" (onClick)="openInviteDialog()" />
      <p-button
        label="New organization"
        icon="pi pi-plus"
        (click)="showCreateDialog.set(true)"
      ></p-button>
    </div>
  </div>

  @if (createNotice(); as notice) {
    <p-message
      [severity]="notice.severity"
      [text]="notice.text"
      [closable]="true"
      (onClose)="createNotice.set(null)"
      styleClass="create-notice"
    ></p-message>
  }

  @if (orgService.errorMessage(); as error) {
    <app-error-banner [message]="error" />
  }

  <p-tabs [value]="activeTab()" (valueChange)="activeTab.set($any($event))">
    <p-tablist>
      <p-tab value="list">Organizations</p-tab>
      <p-tab value="funnel">Onboarding Funnel</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="list">
        <div class="dashboard-grid">
          <div class="card-wrapper">
            <p-card>
              <p-table
                [value]="orgService.organizations()"
                [tableStyle]="{ 'min-width': '50rem' }"
                [paginator]="true"
                [rows]="10"
                [first]="firstRow()"
                (firstChange)="firstRow.set($event)"
                [totalRecords]="orgService.totalCount()"
                [lazy]="true"
                [lazyLoadOnInit]="false"
                (onLazyLoad)="loadData($event)"
                styleClass="p-datatable-striped"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="name">Name <p-sortIcon field="name" /></th>
                    <th pSortableColumn="subscriptionStatus">
                      Status <p-sortIcon field="subscriptionStatus" />
                    </th>
                    <th pSortableColumn="seats">Seats <p-sortIcon field="seats" /></th>
                    <th pSortableColumn="totalUsers">
                      Total Users <p-sortIcon field="totalUsers" />
                    </th>
                    <th pSortableColumn="activeUsers">
                      Active Users <p-sortIcon field="activeUsers" />
                    </th>
                    <th pSortableColumn="totalCost">
                      Period Cost <p-sortIcon field="totalCost" />
                    </th>
                    <th>Actions</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-org>
                  <tr (click)="openDetail(org)" class="clickable-row">
                    <td class="font-medium text-900">{{ org.name }}</td>
                    <td>
                      <p-tag
                        [value]="org.subscriptionStatus"
                        [severity]="getStatusSeverity(org.subscriptionStatus)"
                      ></p-tag>
                    </td>
                    <td class="text-900">{{ org.seats }}</td>
                    <td class="text-900">{{ org.totalUsers }}</td>
                    <td class="text-900">{{ org.activeUsers }}</td>
                    <td class="text-900">{{ org.totalCost | currency: 'EUR' }}</td>
                    <td>
                      <p-button
                        icon="pi pi-search"
                        [rounded]="true"
                        [text]="true"
                        styleClass="text-500"
                      ></p-button>
                      <!-- Opens the organisation rather than deleting it from here. The blast
                           radius and the type-the-name gate cannot be rendered in a table row. -->
                      <p-button
                        icon="pi pi-trash"
                        [rounded]="true"
                        [text]="true"
                        severity="danger"
                        pTooltip="Open to tear down"
                        tooltipPosition="top"
                        (onClick)="openTeardown($event, org)"
                      ></p-button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </p-card>
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel value="funnel">
        @if (aggregateFunnel(); as funnel) {
          <div class="dashboard-grid">
            <div class="card-wrapper">
              <p-card header="Onboarding Funnel (Visible Organizations)">
                <div class="funnel-bar-chart">
                  <div class="funnel-total">
                    <span class="funnel-total-label">Total Users</span>
                    <span class="funnel-total-count">{{ funnel.totalUsers }}</span>
                  </div>
                  @for (step of funnelSteps; track step.key) {
                    <div class="funnel-row">
                      <span class="funnel-label">{{ step.label }}</span>
                      <div class="funnel-bar-track">
                        <div
                          class="funnel-bar-fill"
                          [style.width.%]="getFunnelPercentage(funnel, step.key)"
                          [style.background-color]="step.color"
                        ></div>
                      </div>
                      <span class="funnel-count">
                        {{ getFunnelCount(funnel, step.key) }}
                        <span class="funnel-percent"
                          >({{ getFunnelPercentage(funnel, step.key) }}%)</span
                        >
                      </span>
                    </div>
                  }
                </div>
              </p-card>
            </div>
          </div>
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>

<p-dialog
  header="Invite Organization"
  [visible]="showInviteDialog()"
  (visibleChange)="showInviteDialog.set($event)"
  [modal]="true"
  [style]="{ width: '70vw', maxWidth: '640px' }"
  [draggable]="false"
  [resizable]="false"
>
  <form [formGroup]="inviteForm" class="invite-form">
    <label for="orgName">Organization name</label>
    <div class="invite-autocomplete">
      <p-autoComplete
        inputId="orgName"
        formControlName="name"
        [suggestions]="companySuggestions()"
        (completeMethod)="searchCompany($event)"
        (onSelect)="onCompanySelect($event)"
        optionLabel="name"
        placeholder="Search the company register, or type a name..."
        appendTo="body"
        [showEmptyMessage]="false"
        fluid
      />
      @if (companySelected()) {
        <p-button
          icon="pi pi-pencil"
          [text]="true"
          severity="secondary"
          size="small"
          pTooltip="Change organization"
          (onClick)="clearCompanySelection()"
        />
      }
    </div>
    @if (inviteForm.controls.name.invalid && inviteForm.controls.name.touched) {
      <small class="invite-error">Name is required.</small>
    }

    @if (inviteForm.controls.registrationCode.value || inviteForm.controls.address.value) {
      <div class="invite-registry-details">
        @if (inviteForm.controls.registrationCode.value) {
          <small>Reg: {{ inviteForm.controls.registrationCode.value }}</small>
        }
        @if (inviteForm.controls.address.value) {
          <small>{{ inviteForm.controls.address.value }}</small>
        }
      </div>
    }

    <label for="adminEmail">Admin email</label>
    <input id="adminEmail" type="email" pInputText formControlName="adminEmail" fluid />
    @if (inviteForm.controls.adminEmail.invalid && inviteForm.controls.adminEmail.touched) {
      <small class="invite-error">A valid email is required.</small>
    }
  </form>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      severity="secondary"
      [text]="true"
      (onClick)="showInviteDialog.set(false)"
    />
    <p-button
      label="Send invite"
      icon="pi pi-check"
      [disabled]="inviteForm.invalid"
      (onClick)="sendInvite()"
    />
  </ng-template>
</p-dialog>

<p-toast />

<app-create-organization-dialog
  [(visible)]="showCreateDialog"
  (created)="onOrganizationCreated($event)"
/>
